import {
  TPivotPresetName,
  TPivotReport,
} from '@infotech-soe/merps/types/Reports';
import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import { AppState } from '../../../store/reducers/root';
import {
  getPivotPresetNames,
  getPivotState,
} from '../../../store/selectors/pivot';
import { isDarkTheme } from '../../../store/selectors/theme';
import pivot from '../../../store/slices/pivot';

import PivotReportDialog from './PivotReportDialog';

const mapStateToProps = (state: AppState) => {
  const { dataSource, config, code, show } = getPivotState(state);

  return {
    dataSource,
    config,
    code,
    presetNames: getPivotPresetNames(state),
    show,
    isDarkMode: isDarkTheme(state),
  };
};

const mapDispatchToProps = {
  onClose: pivot.close,
  onError: pivot.openFailure,
  onOpenPreset: pivot.openPreset,
  onSavePreset: pivot.savePreset,
};

const mergeProps = (
  stateProps: ReturnType<typeof mapStateToProps>,
  { onOpenPreset, onSavePreset, ...dispatchProps }: typeof mapDispatchToProps
) => ({
  ...stateProps,
  ...dispatchProps,
  onSavePreset: (
    presetName: TPivotPresetName,
    report: TPivotReport,
    isClosed: boolean
  ) => {
    onSavePreset({ presetName, report, isClosed });
  },
  onSelectPreset: (presetName?: TPivotPresetName): void => {
    if (presetName) onOpenPreset({ presetName });
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export type PivotReportDialogProps = ConnectedProps<typeof connector>;

export default connector(PivotReportDialog);
